export default "__VITE_ASSET__BZ9mp2ge__"